import { defaultScale } from '../config/defaults';

import ScribeElementModel from './ScribeElementModel';

class ScribeImageElementModel extends ScribeElementModel {
  _imageUrl = null;

  constructor(data) {
    super(data, 'Image');

    if (data._imageUrl) {
      this._imageUrl = data._imageUrl;
    }

    if (data && data.id) {
      this.image = data.image;
      this.opacity = data.opacity;
    } else {
      this.scaleX = defaultScale;
      this.scaleY = defaultScale;
      this.opacity = 1;
    }
  }

  delete(propName) {
    delete this[propName];
  }
}

export default ScribeImageElementModel;
